import { render, staticRenderFns } from "./GuildItem.vue?vue&type=template&id=dbb26158&"
import script from "./GuildItem.vue?vue&type=script&lang=js&"
export * from "./GuildItem.vue?vue&type=script&lang=js&"
import style0 from "./GuildItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports